import React, { useState } from 'react';
import InventoryCards from './InventoryCards';
import LowStockTable from './LowStockTable';
import UsageChart from './UsageChart';
import QuickActions from './QuickActions';

const MainInventory = () => {
  const [activeProperty, setActiveProperty] = useState('All Properties');
  const [timeRange, setTimeRange] = useState('7d');

  // Initialize inventoryItems state with your dummy data
  const [inventoryItems, setInventoryItems] = useState([
    {
      id: 1,
      name: 'Bath Towel',
      category: 'linen',
      quantity: 450,
      threshold: 100,
      reusable: true,
      property: 'all',
      roomSpecific: false,
    },
    {
      id: 2,
      name: 'Shampoo',
      category: 'toiletries',
      quantity: 120,
      threshold: 50,
      reusable: false,
      property: 'all',
      roomSpecific: false,
    },
    {
      id: 3,
      name: 'Bathrobes',
      category: 'amenities',
      quantity: 120,
      threshold: 30,
      reusable: true,
      property: 'grand',
      roomSpecific: true,
    },
  ]);

  // Dummy data
  const properties = ['All Properties', 'Grand Hotel', 'Seaside Resort', 'Mountain Lodge'];

  const categories = [
    { name: 'Towels', total: 180, damaged: 10, reusable: true },
    { name: 'Shampoo', total: 250, damaged: 5, reusable: false },
    { name: 'Bathrobes', total: 120, damaged: 3, reusable: true },
    { name: 'Coffee Pods', total: 320, damaged: 0, reusable: false },
  ];

  const lowStockItems = [
    {
      id: 1,
      name: 'Hand Towels',
      current: 12,
      threshold: 20,
      category: 'Towels',
      lastOrdered: '2023-05-01',
    },
    {
      id: 2,
      name: 'Bathrobes',
      current: 8,
      threshold: 15,
      category: 'Bathrobes',
      lastOrdered: '2023-04-28',
    },
    {
      id: 3,
      name: 'Shower Caps',
      current: 5,
      threshold: 25,
      category: 'Toiletries',
      lastOrdered: '2023-04-15',
    },
  ];

  const usageData = {
    labels: ['Towels', 'Shampoo', 'Bathrobes', 'Coffee', 'Soap'],
    values: [45, 38, 22, 30, 28],
  };

  const handleAddItem = (newItem) => {
    setInventoryItems((prev) => [
      ...prev,
      {
        id: Date.now(),
        ...newItem,
        quantity: parseInt(newItem.quantity),
        threshold: parseInt(newItem.threshold),
      },
    ]);
    // In a real app, you would also add to your logs here
  };

  const handleRefresh = () => {
    // Implement refresh logic (fetch from API in a real app)
    alert('Screen is refreshed');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Inventory Management</h1>
        <div className="flex items-center justify-end mt-4">
          {/* <div className="flex space-x-4">
            <select
              className="bg-white border border-gray-300 rounded-md px-4 py-2 shadow-sm"
              value={activeProperty}
              onChange={(e) => setActiveProperty(e.target.value)}
            >
              {properties.map((property) => (
                <option key={property} value={property}>
                  {property}
                </option>
              ))}
            </select>
            <select
              className="bg-white border border-gray-300 rounded-md px-4 py-2 shadow-sm"
              value={timeRange}
              onChange={(e) => setTimeRange(e.target.value)}
            >
              <option value="24h">Last 24h</option>
              <option value="7d">Last 7 days</option>
              <option value="30d">Last 30 days</option>
            </select>
          </div> */}
          <QuickActions onRefresh={handleRefresh} onAddItem={handleAddItem} />
        </div>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-8">
        {categories.map((category) => (
          <InventoryCards key={category.name} category={category} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Low Stock Warnings</h2>
          <LowStockTable items={lowStockItems} />
        </div>

        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Usage Summary</h2>
          <UsageChart data={usageData} />
        </div>
      </div>
    </div>
  );
};

export default MainInventory;
